import React from 'react'
import { Link } from 'react-router-dom'
import { Settings, Users, BarChart, FlaskConical, SearchCheck, ListChecks, MessagesSquare, Smartphone } from 'lucide-react'

const AdminConsole: React.FC = () => {
  // Full class names, not `bg-${color}-100` — Tailwind scans source text, so an
  // interpolated color only works when some other file spells it out literally.
  const adminSections = [
    {
      title: 'Configuration',
      description: 'Manage system settings and configurations',
      link: '/config',
      icon: Settings,
      tile: 'bg-amber-100',
      iconColor: 'text-amber-800'
    },
    {
      title: 'All Advisors',
      description: 'View and manage all advisors in the system',
      link: '/advisors',
      icon: Users,
      tile: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      title: 'LLM Usage',
      description: 'Token usage overall and per user',
      link: '/admin/llm-usage',
      icon: BarChart,
      tile: 'bg-amber-100',
      iconColor: 'text-amber-800'
    },
    {
      title: 'Parse Quality',
      description: 'Parser edit rates, failure cases and feedback',
      link: '/admin/parse-quality',
      icon: SearchCheck,
      tile: 'bg-teal-100',
      iconColor: 'text-teal-600'
    },
    {
      title: 'Manage Users',
      description: 'Search a user and reset their token usage',
      link: '/admin/users',
      icon: Users,
      tile: 'bg-amber-100',
      iconColor: 'text-amber-600'
    },
    {
      title: 'Test Tracker',
      description: 'Suite-run history, trends and flaky tests',
      link: '/admin/tests',
      icon: FlaskConical,
      tile: 'bg-rose-100',
      iconColor: 'text-rose-600'
    },
    {
      title: 'Jobs',
      description: 'Background jobs: watch, cancel, retry',
      link: '/admin/jobs',
      icon: ListChecks,
      tile: 'bg-teal-100',
      iconColor: 'text-teal-600'
    },
    {
      title: 'Viewport',
      description: 'Screen geometry and what last changed it',
      link: '/admin/viewport',
      icon: Smartphone,
      tile: 'bg-sky-100',
      iconColor: 'text-sky-600'
    },
    {
      title: 'Chat Inspector',
      description: 'Any chat: every item, tool call and turn',
      link: '/admin/chats',
      icon: MessagesSquare,
      tile: 'bg-rose-100',
      iconColor: 'text-rose-600'
    }
  ]

  return (
    <div className="flex flex-col min-h-screen bg-blush-light">
      <div className="container mx-auto px-4 pb-8 sm:pt-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Admin Console</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {adminSections.map((section) => {
            const Icon = section.icon
            return (
              <Link
                key={section.link}
                to={section.link}
                className="block bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
              >
                <div className="p-6">
                  <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg ${section.tile} mb-4`}>
                    <Icon className={`w-6 h-6 ${section.iconColor}`} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {section.title}
                  </h3>
                  <p className="text-gray-600">
                    {section.description}
                  </p>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default AdminConsole